module.exports = __webpack_public_path__ + "img/stop_btn.457d71e4.png";